import Rupee from "../../../core/assets/oot/classic/Green_Rupee_Artwork.png"
import GossipStone from "../../../core/assets/oot/classic/OoT_Gossip_Stone_Model.png"
import RecoveryHeart from "../../../core/assets/oot/classic/OoT_Recovery_Heart_Model.png"
import Token from "../../../core/assets/oot/classic/OoT_Token_Icon.png"
import Chest from "../../../core/assets/oot/classic/chest.png"
import Cow from "../../../core/assets/oot/classic/cow.png"
import Pot from "../../../core/assets/oot/classic/pot.png"
import { CheckSubTypeEnum } from "../CheckDataType"

interface SubTypeUiData {
    color: string,
    img: string,
    width?: number
}

export function getSubTypeData(id: number) {
    switch (id) {
        case CheckSubTypeEnum.Chest:
            return { color: "lightblue", img: Chest } as SubTypeUiData
        case CheckSubTypeEnum.Pot:
            return { color: "brown", img: Pot } as SubTypeUiData
        case CheckSubTypeEnum.Rupee:
            return { color: "lightgray", img: Rupee, width: 20 } as SubTypeUiData
        case CheckSubTypeEnum.RecoveryHeart:
            return { color: "lightred", img: RecoveryHeart } as SubTypeUiData
        case CheckSubTypeEnum.GossipStone:
            return { color: "gray", img: GossipStone } as SubTypeUiData
        case CheckSubTypeEnum.GoldenSkulltula:
            return { color: "gold", img: Token } as SubTypeUiData
        case CheckSubTypeEnum.Crate:
            return {} as SubTypeUiData
        case 8:
            return {} as SubTypeUiData
        case 9:
            return {} as SubTypeUiData
        case 10:
            return {} as SubTypeUiData
        case 11:
            return {} as SubTypeUiData
        case CheckSubTypeEnum.Cow:
            return { color: "gold", img: Cow } as SubTypeUiData
        case 13:
            return {} as SubTypeUiData
        case 14:
            return {} as SubTypeUiData
        case 15:
            return {} as SubTypeUiData
        case 16:
            return {} as SubTypeUiData
        case 17:
            return {} as SubTypeUiData
        case 18:
            return {} as SubTypeUiData
        case 19:
            return {} as SubTypeUiData
        case 20:
            return {} as SubTypeUiData
        case 21:
            return {} as SubTypeUiData
        case 22:
            return {} as SubTypeUiData
        case 23:
            return {} as SubTypeUiData

        default:
            return {} as SubTypeUiData
    }
}